<template>
    <div class="home-main">
        <!-- <headers :btnshow="showlistbtn" @clickbtn="showlist"></headers> -->
        <!-- <div class="swicth_home_1"></div> -->
        <div class="home-body">
            <div class="home-list" :style="`${showlistbtn?'left:0px;':''}`">
                <list @clickbtn="showlistbtn = false"></list>
            </div>
            <div class="home-nowpage">
                <!-- <tabs class="tabs"></tabs> -->
                <!-- <div class="home-con" :style="'min-height:'+hei+'px;'"> -->
                <div class="home-con">
                    <router-view />
                </div>
                <!-- <div class="movecon" :style="'height:'+hei+'px'" @click="showlistbtn = false">
                    <router-view />
                </div> -->
            </div>
            <div style="float:none;clear:both"></div>
        </div>
    </div>
</template>

<script>
// import headers from "./Header.vue";
import list from "./List.vue";
// import tabs from "./Tabs.vue";
export default {
    name: "Home",
    components: { list },
    data(){
        return{
            hei:null,
            showlistbtn:false,
        }
    },
    methods:{
        showlist(){
            this.showlistbtn = !this.showlistbtn
        }
    },
    created(){
        this.hei = this.$store.state.hei-80   //get page height
        if(this.$store.state.wid < 769){
            this.hei = this.$store.state.hei-(this.$store.state.wid/20*3.4)
        }
        let path = this.$route.path
        this.$store.state.allDom.some(item => {
            if(item.path === path){
                this.$store.commit('modifyData',{name:'showDom',newdata:[item]})
                return true
            }
        })
        // 获取文件展示默认地址
        this.$request('/manage/file/baseUrl',{},res => {
            if(res.data.code === 200){
                this.$store.commit('modifyData',{newdata:res.data.data,name:'default_file_url'})
            }
        },'post',true)
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.swicth_home_1{
height:15px;width:100%
}
.home-body{
    /* min-width: 1524px; */
    position: relative;
    display: flex;  
    flex: 1;
}
.home-main{
    background-color: rgb(238,238,238);
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
}
.vertical_wall{
    width: 0.7%;
    height: 500px;
    min-width: 15px;
}
.home-list{
    flex: 1.5;
    background-color: white;
    min-width: 210px;
    position: relative;
    box-sizing: border-box;
    padding: 20px 0 0;
    border-right: 1px solid rgba(234,237,242);
}
.home-nowpage{
    flex: 8;
    box-sizing: border-box;
    /* min-width: 1300px; */
    overflow-y: auto;
    position: relative;
    /* padding: 0 1.2%; */
}
.home-con{
    background-color: rgb(255, 255, 255);
    overflow: hidden;
    overflow-y: auto;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    position: absolute;
}
.movecon{
    display: none;
    overflow: auto;
}
</style>
